export enum TemperatureIssueType {
    WITHOUT_REFRIGERATION = 'Received without refrigeration',
    OUTSIDE_OF_EXPECTED_TEMPERATURE = 'Received outside of expected temperature',
    QUESTIONABLE_STABILITY = 'Questionable stability of product',
    LATE_DELIVERY_OUTSIDE_OF_EXPECTED_TEMPERATURE = 'Late Delivery and outside of expected temperature'
}
